/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum WorkItemDescriptionDisplayMode {
    Show = 0,
    Hide = 1,
    Hover = 2,
}
